import { APIs } from "../../util/api/APIs";
import SafeairManager from "../../util/api/SafeairManager";
import { IEmsResponse } from "./typings/IEmsResponse";

export default class MedicalEmergencyService {
  static async listEmsProviders() {
    const apiConfig = {
      api: APIs.EMS.ListEms,
      parameters: null,
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data as IEmsResponse[];
  }
}
